import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageVariables } from '../../shared/constants/app.enum';
import { StorageService } from '../services/storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private readonly localStorage = inject(StorageService);
  private readonly router = inject(Router);

  canActivate() {
    const token = this.localStorage.get(StorageVariables.TOKEN);

    if (token) return true;

    this.router.navigate(['/auth/login']);
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class NotAuthGuard {
  private readonly localStorage = inject(StorageService);
  private readonly router = inject(Router);

  canActivate() {
    const token = this.localStorage.get(StorageVariables.TOKEN);

    if (!token) return true;

    this.router.navigate(['/']);
    return false;
  }
}
